import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { PagedResult, ProjectSearchResultDto, QueryOptions } from '../lib/types';

export interface ProjectsSearchOptions extends QueryOptions {
  office?: string;
  serviceLine?: string;
}

/**
 * Projects-only search for the saved-filter picker. `filter` (from QueryOptions) is sent as
 * `q` — a job number or project name substring. `office`/`serviceLine` filter directly on the
 * project's account/service line.
 */
export function useProjectsSearch(options: ProjectsSearchOptions) {
  const params = new URLSearchParams();
  if (options.filter) params.set('q', options.filter);
  if (options.office) params.set('office', options.office);
  if (options.serviceLine) params.set('serviceLine', options.serviceLine);
  if (options.page) params.set('page', String(options.page));
  if (options.pageSize) params.set('pageSize', String(options.pageSize));
  if (options.sortBy) params.set('sortBy', options.sortBy);
  if (options.sortDesc != null) params.set('sortDesc', String(options.sortDesc));

  return useQuery({
    queryKey: ['projects-search', options],
    queryFn: () => apiClient.get<PagedResult<ProjectSearchResultDto>>(`/api/projects/search?${params}`),
  });
}
